export default {"src":"/_next/static/media/underview.bb013940.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};